import { Component, OnInit } from '@angular/core';
import { QnaReportDownloadService } from '../Services/qna-report-download.service';
import { ColDef, GridReadyEvent, GridApi, CellClickedEvent } from 'ag-grid-community';  

@Component({
    selector: 'app-qna-report-download',
    templateUrl: './qna-report-download.component.html',
    styleUrls: [],
    providers: [QnaReportDownloadService]
})

export class QnaReportDownloadComponent implements OnInit {

    constructor(public dataService: QnaReportDownloadService) { }

    qnaReportDownloadViewModel;
    public gridApi!: GridApi;

    configColumnDefs: ColDef[] = [
        { field: 'Configuration', resizable: false },
        { field: 'Value', resizable: false }
    ];

    configRowData = [];

    reportColumnDefs: ColDef[] = [
        { field: 'Timeframe', resizable: false },
        { field: 'Links', resizable: false, cellClass: ['report-download-block'], onCellClicked: (event: CellClickedEvent) => { this.downloadReport(event) } }
    ]

    reportRowData;

    ngOnInit() {
        this.dataService.getAvailableReportsTimeFrames().subscribe(res => {
            this.qnaReportDownloadViewModel = res
            this.configRowData = [
                { Configuration: 'Selected Timeframe', Value: res.SelectedTimeFrame.split(',').map(word => word.trim()).join(', ') },
                { Configuration: 'Selected Report type', Value: res.SelectedReportTypes.split(',').map(word => this.formatReportTypes(word.trim())).join(', ') },
                { Configuration: 'Send Email Notification', Value: `${res.SendEmailNotification}` }
            ];

            this.reportRowData = this.qnaReportDownloadViewModel.AvailableReportTimeFrames.map(tf => ({ Timeframe: tf, Links: 'Download' }))
        })
    }


    formatReportTypes(word) {
        switch (word) {
            case 'QuesAskedAndAnswered':
                return this.capitalizeFirstLetter(word.replace('Ques', 'Questions').split(/(?=[A-Z])/).join(' '))
            case 'QuesAskedButNotAnswered':
                return this.capitalizeFirstLetter(word.replace('Ques', 'Questions').split(/(?=[A-Z])/).join(' '))
            case 'QuesDeleted':
                return this.capitalizeFirstLetter(word.replace('Ques', 'Questions').split(/(?=[A-Z])/).join(' '))
            default:
                return ''
        };
    }

      onGridReady(params: GridReadyEvent) {
        this.gridApi = params.api;
        this.gridApi.setDomLayout("autoHeight");
        this.gridApi.setRowData(this.configRowData);
    }

    onGridReady1(params: GridReadyEvent) {
        this.gridApi = params.api;
        this.gridApi.setDomLayout("autoHeight");
        this.gridApi.setRowData(this.reportRowData);
    }

    capitalizeFirstLetter(sentence: string): string {
    if (!sentence) return sentence;
    return sentence.charAt(0).toUpperCase() + sentence.slice(1).toLowerCase();
}


    downloadReport(event) {
        if (event.data.Timeframe == undefined || event.data.Timeframe == null)
            return

        this.dataService.downloadReports(event.data.Timeframe).subscribe(response => {
            const blob = new Blob([response], { type: 'application/vnd.ms-excel' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `Q&A_Report_${event.data.Timeframe}.xlsx`;
            link.click();
        });
    }
}